import { offlineActionCreator } from "actions/lib";

import {
  AppUpdateAction,
  REFRESH_INTERVAL,
  SERVER_HEARTBEAT,
  SET_LAST_KNOWN_VERSION,
} from "constants/actionTypes";

export function updateRefreshInterval(refreshIntervalMs) {
  return {
    type: REFRESH_INTERVAL.ACTION,
    refreshIntervalMs,
  };
}

const urlCreator = () => `/v2/heartbeat/`;

export const ServerHeartbeatAction = offlineActionCreator(
  SERVER_HEARTBEAT,
  () => {},
  urlCreator,
  false,
);

export function appUpdateLogoutRequired() {
  return {
    type: AppUpdateAction.LOGOUT_REQUIRED,
  };
}

export function appUpdateRefreshRequired() {
  return {
    type: AppUpdateAction.REFRESH_REQUIRED,
  };
}

export function appUpdateRefreshOptional() {
  return {
    type: AppUpdateAction.REFRESH_OPTIONAL,
  };
}

export function appUpdateInvisible() {
  return {
    type: AppUpdateAction.INVISIBLE,
  };
}

export function appUpdateComplete() {
  return {
    type: AppUpdateAction.COMPLETE,
  };
}

export function setLastKnownVersion(version) {
  return {
    type: SET_LAST_KNOWN_VERSION,
    version,
  };
}
